import PropTypes from 'prop-types';
import React from 'react';
import { get, pageContext, getQueryVariable } from 'ctm-util-functions';
import { connect } from 'react-redux';

import { Button } from '../button/button';

/**
 * Back Button Component
 * @param {Object} props React props
 * @desc A basic Button component wrapper that fires the browserhistory.
 * goBack function on click
 * @returns {BackButton} a BackButton component
 */
const _BackButton = (props) => {
    /**
     * On Click event
     * @param  {Object} event - the event details.
     */

    const browserHistory = pageContext.getProps().browserHistory;

    const onClick = (event) => {
        event.preventDefault();
        browserHistory.goBack();
    };

    /**
     * Render a Button component with the appropriate data-id and onClick method
     * @returns {Node} a BackButton component
     */

    const pageName = get(pageContext.getProps(), 'pageState.pageName', 'unset');

    const { elementProps = {}, visualProps, contentProps, className = null, currentState } = props;
    if (!elementProps['data-id']) {
        elementProps['data-id'] = `${pageName}.backButton`;
    }

    const backButtonElement = document.getElementById(`${pageName}.backButton`);
    const nextButtonElement = document.getElementById(`${pageName}.nextButton`);

    const previousUrl = currentState.page.previousLocation.pathname || '/'; // Handle case where previousUrl may not be defined
    const currentUrl = currentState.page.location.pathname;

    // These URLS are related to the start of the bucket
    const bucketFirstPage = [
        'car-insurance/journey/car_make',
        'car-insurance/journey/factory_options',
        'car-insurance/journey/regular_driver_gender',
        'car-insurance/journey/youngest_driver',
        'car-insurance/journey/driver_option',
        'car-insurance/journey/car_address',
        'car-insurance/journey/applicant_details',
        'car-insurance/journey/accident_hail_damage',
        'car-insurance/journey/commencement_date'
    ];

    // If any of these URLs were the previous URL, then hide the back button
    const bucketSecondPage = [
        '/car-insurance/journey/car_year',
        '/car-insurance/journey/modifications',
        '/car-insurance/journey/security_features',
        '/car-insurance/journey/factory_options',
        '/car-insurance/journey/overnight_parking_type',
        '/car-insurance/journey/regular_driver_dob',
        '/car-insurance/journey/non_standard_accessories',
        '/car-insurance/journey/youngest_driver_gender',
        '/car-insurance/journey/commencement_date',
        '/car-insurance/journey/edit_car_details',
        '/car-insurance/journey/standard_options',
        '/car-insurance/journey/driver_option'
    ];

    // check if we are at the start of the bucket based on current URL
    const isBucketFirstPage = bucketFirstPage.some((bucket) => currentUrl.includes(bucket));
    // check if previousURL is the second page of the current bucket
    const isBucketSecondPage = bucketSecondPage.some((bucket) => previousUrl.includes(bucket));

    const regularDriverBackButton = document.getElementById('regular_driver_gender.backButton');
    const carMakeBackButton = document.getElementById('car_make.backButton');

    if (previousUrl === '/car-insurance/journey/results'
        || (currentState.page.hasSeenResults && currentUrl === '/car-insurance/journey/regular_driver_gender')) {
        if (regularDriverBackButton) {
            regularDriverBackButton.style.visibility = 'hidden';
        }
    }

    if (previousUrl === '/car-insurance/journey/results'
        || (currentState.page.hasSeenResults && currentUrl === '/car-insurance/journey/car_make')) {
        if (carMakeBackButton) {
            carMakeBackButton.style.visibility = 'hidden';
        }
    }

    // User has seen confirmation page, backbutton exists and we are at the start of the bucket
    if (currentState.page.hasSeenConfirmation && backButtonElement && isBucketFirstPage && getQueryVariable('isEdit')) {
        backButtonElement.style.visibility = 'hidden';
        // if User did not route from confirmation page and we are at the start of the bucket but we navigated from in-journey
        // eg back button should be shown for factory_options if we arrive from cover_type
        if (previousUrl !== '/car-insurance/journey/confirmation' && !isBucketSecondPage && isBucketFirstPage) {
            backButtonElement.style.visibility = 'visible';
        }

        // handle case where user is not start of the bucket, but one of the pages is start of the bucket inside another bucket
        if (
            (previousUrl !== '/car-insurance/journey/confirmation'
                && currentUrl === '/car-insurance/journey/regular_driver_gender'
                && previousUrl === '/car-insurance/journey/overnight_parking_type')
            || currentUrl === '/car-insurance/journey/youngest_driver_dob'
        ) {
            backButtonElement.style.visibility = 'visible';
        }
    }

    // With the addition of prefill_check on HNC journey, the start page is now the 2nd page of the journey, we will now hide the back button
    if (currentState.page.location.pathname === '/home-contents-insurance/journey/start' && backButtonElement) {
        backButtonElement.parentElement.style.display = 'none';
        nextButtonElement.parentElement.style.paddingLeft = '0';
    }

    return (
        // @todo remove the shaped props for parent component
        <Button className={className} {...contentProps} {...visualProps} {...elementProps} onClickFunction={onClick} />
    );
};

_BackButton.propTypes = {
    className: PropTypes.string,
    contentProps: PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string,
        iconPosition: PropTypes.string
    }),
    visualProps: PropTypes.shape({
        UIComponent: PropTypes.string,
        display: PropTypes.string
    }),
    elementProps: PropTypes.shape({
        tagName: PropTypes.string,
        'data-id': PropTypes.string
    })
};

const mapStateToProps = (state) => {
    const currentState = JSON.parse(JSON.stringify(state)) || state;
    return { currentState };
};

const BackButton = connect(mapStateToProps)(_BackButton);

// Export the Enhanced component.
export { _BackButton, BackButton };
